var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.565,
    height: 101.565,
    viewBox: "0 0 101.565 101.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61978",
    "data-name": "Path 61978",
    d: "M0,0H101.565V101.565H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61979",
    "data-name": "Path 61979",
    d: "M79.174,70.71V11.464A8.489,8.489,0,0,0,70.71,3H11.464A8.489,8.489,0,0,0,3,11.464V70.71a8.489,8.489,0,0,0,8.464,8.464H70.71A8.489,8.489,0,0,0,79.174,70.71Zm-52.9-23.275,10.58,12.738L51.667,41.087,70.71,66.478H11.464Z",
    transform: "translate(9.696 9.696)",
    fill: "#29e67c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.44ed5014d23150bec5a59dc903c333db.svg";
export { ForwardRef as ReactComponent };